import {Routes} from '@angular/router';
import {PlatformLinkCreatorComponent} from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';
import {PlatformToolContainerComponent} from '@shared/components/platform-tool/platform-tool-container/platform-tool-container.component';
import {DataMappingCanDeactivateGuard} from '@features/data-mapping/guards/data-mapping-can-deactivate.guard';

export const dataMappingRoutes: Routes = [
  {
    path: 'data-mapping',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'data-mapping/field-mapping',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'data-mapping/field-mapping/:magicLinkId',
    component: PlatformToolContainerComponent,
    canDeactivate: [DataMappingCanDeactivateGuard]
  },
  {
    path: 'data-mapping/field-mapping/used-in/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'data-mapping/entity-mapping',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'data-mapping/entity-mapping/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'data-mapping/entity-mapping/manage-entities/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'data-mapping/stream-mapping',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'data-mapping/stream-mapping/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'data-mapping/entity-type-mapping',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'data-mapping/entity-type-mapping/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'data-mapping/eat/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'data-mapping/value-mapping',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'data-mapping/value-mapping/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'data-mapping/growth-assumptions',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'data-mapping/growth-assumptions/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'data-mapping/trial-balance-mappings',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'data-mapping/trial-balance-mappings/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'data-mapping/reports',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'data-mapping/reports/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'data-mapping/data-extractors',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'data-mapping/data-extractors/:magicLinkId',
    component: PlatformToolContainerComponent
  },
];


